import {
  Castle,
  ExternalLink,
  MapPin,
} from "lucide-react";
import Reveal, { SectionHeader } from "./Reveal";
import { MAPS_URL, WEDDING } from "@/data/wedding";

const VENUES = [
  {
    id: "domaine",
    icon: Castle,
    name: WEDDING.domaine.name,
    address: WEDDING.domaine.address,
    time: `Réception dès ${WEDDING.domaine.time}`,
    note: WEDDING.domaine.note,
    testid: "map-button-domaine",
  },
];

export default function Informations() {
  return (
    <section id="informations" className="scroll-mt-20 py-24 lg:py-32">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <SectionHeader
          eyebrow="01 — Informations"
          title={
            <>
              Le programme de la journée
            </>
          }
          subtitle="Tout ce qu'il faut savoir pour partager cette journée avec nous, du vin d'honneur jusqu'à la dernière danse."
        />

        <div className="relative mt-16 space-y-12 pl-8 sm:pl-10">
          <span
            aria-hidden
            className="absolute bottom-2 left-[7px] top-2 w-px bg-line sm:left-[11px]"
          />
          {WEDDING.program.map((item, i) => {
            return (
              <Reveal key={item.title} delay={i * 0.06} className="relative">
                <span
                  aria-hidden
                  className="absolute -left-8 top-1.5 flex h-[15px] w-[15px] items-center justify-center rounded-full border-2 border-terracotta bg-sand sm:-left-10"
                />
                <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
                  <span className="font-mono text-sm text-terracotta">{item.time}</span>
                  <h3 className="font-serif text-2xl text-ink sm:text-3xl">{item.title}</h3>
                </div>
                <p className="mt-2 max-w-xl leading-relaxed text-taupe">{item.desc}</p>
              </Reveal>
            );
          })}
        </div>

        <div className="mx-auto mt-24 grid max-w-2xl gap-6">
          {VENUES.map((v, i) => (
            <Reveal key={v.id} delay={i * 0.1} className="h-full">
              <div className="relative flex h-full flex-col overflow-hidden rounded-3xl border border-line p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(44,38,35,0.08)] lg:p-10">
                <img
                  src="https://www.domainedeletabliere.com/wp-content/uploads/2025/12/Map-final-min.png"
                  alt=""
                  aria-hidden
                  className="absolute inset-0 h-full w-full object-cover"
                  loading="lazy"
                />
                <div aria-hidden className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/25 to-ink/10" />
                <div className="relative flex h-full flex-col">
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-ink/40 text-white backdrop-blur-sm">
                    <v.icon className="h-5 w-5" strokeWidth={1.5} />
                  </span>
                </div>
                <h3 className="mt-6 font-serif text-3xl font-semibold text-white">{v.name}</h3>
                <p className="mt-3 flex items-start gap-2 font-medium leading-relaxed text-white">
                  <MapPin className="mt-1 h-4 w-4 shrink-0 text-gold" />
                  {v.address}
                </p>
                <a
                  href={MAPS_URL(`${v.name}, ${v.address}`)}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={v.testid}
                  className="mt-auto inline-flex w-fit items-center gap-2 rounded-full bg-ink px-6 py-3 pt-3 text-sm font-medium text-sand transition-all duration-300 hover:-translate-y-0.5 hover:bg-terracotta"
                  style={{ marginTop: "2rem" }}
                >
                  Itinéraire Google Maps
                  <ExternalLink className="h-4 w-4" />
                </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
